import { useEffect, useState } from 'react';
import { useCallbackRef } from '../utils/use-callback-ref.js';
import { componentLightTokens } from './component-vars.css.js';
import { componentDarkTokens } from './component-vars.css.js';
import { detectThemeMode } from './detect-theme-mode.js';
import {
  ThemeColorsProvider,
  ThemeModeProvider,
  ThemeSwitchProvider,
} from './theme-context';
import { darkTheme, lightTheme, systemTheme } from './theme.css.js';

type ThemeMode = 'light' | 'dark';

export const ThemeProvider = ({
  children,
  mode,
  onChange,
}: {
  children: React.ReactNode;
  mode?: ThemeMode;
  onChange?: (theme: ThemeMode) => void;
}) => {
  const [theme, setTheme] = useState(() => mode || detectThemeMode());

  const tokens = theme === 'light' ? componentLightTokens : componentDarkTokens;

  useEffect(() => {
    if (theme === 'dark') {
      document.documentElement.classList.remove(systemTheme);
      document.documentElement.classList.remove(lightTheme);
      document.documentElement.classList.add(darkTheme);
      document.documentElement.style.setProperty('color-scheme', 'dark');
    } else {
      document.documentElement.classList.remove(systemTheme);
      document.documentElement.classList.remove(darkTheme);
      document.documentElement.classList.add(lightTheme);
      document.documentElement.style.setProperty('color-scheme', 'light');
    }
  }, [theme]);

  const switchTheme = useCallbackRef((theme: ThemeMode) => {
    setTheme(theme);

    onChange?.(theme);
  });

  return (
    <ThemeModeProvider value={theme}>
      <ThemeSwitchProvider value={switchTheme}>
        <ThemeColorsProvider value={tokens}>{children}</ThemeColorsProvider>
      </ThemeSwitchProvider>
    </ThemeModeProvider>
  );
};
